import { FILTER_SAVED } from '../actionTypes/partner.types';

export function saveFilterPartner(data: object) {
  return {
    type: FILTER_SAVED,
    payload: {
      ...data,
    },
  };
}
